import React from 'react';
import Card from '../../../muiComponents/Card';
import Tag from '../../../muiComponents/Tag';
import Image from '../../components/Image';
import Tooltip from '../../../muiComponents/Tooltip';
import Flag from '../components/Flag';
import Icon from '../../../muiComponents/Icon';
import { MemberState } from '../../../types/zinantis/members/membersType';

interface MemberCardProps {
    member: MemberState;
    visibleSegmentName: boolean;
    visibleNewMember?: boolean;
    className?: string;
    onClick?: () => void;
}

const MemberCard = (props: MemberCardProps) => {
    const {
        member,
        onClick,
        visibleSegmentName,
        visibleNewMember = false,
        className,
    } = props;
    return (
        <Card
            className={`member-card__container ${className || ''}`}
            onClick={onClick}
        >
            {visibleNewMember && member.isNew && (
                <span className='member-card__new-tag'>
                    <Tag text='new' color='pink' />
                </span>
            )}
            <div className='member-card__logo-container'>
                {member.logo ? (
                    <Image className='member-card__image' src={member.logo} />
                ) : (
                    <div className='member-card__logo-name'>
                        <p>{member.name}</p>
                    </div>
                )}
            </div>
            <div className='member-card__title'>
                <div className='flex-column gap-5'>
                    <h5>{member.name}</h5>
                    {visibleSegmentName && (
                        <Tooltip titleText={member.accountManagementSegment}>
                            <p className='text-overflow-ellipsis text-size-16'>
                                {member.accountManagementSegment}
                            </p>
                        </Tooltip>
                    )}
                </div>
                <div className='flex flex-align-center flex-between gap-5'>
                    <div className='flex gap-5 flex-align-center'>
                        {member.countryCode && (
                            <Flag
                                text={member.country}
                                code={member.countryCode}
                                style={{ width: '16px', height: '12px' }}
                            />
                        )}
                        <Tooltip
                            titleText={member.country ? member.country : ''}
                        >
                            <p className='text-overflow-ellipsis '>
                                {member.country ? member.country : ''}
                            </p>
                        </Tooltip>
                    </div>
                    <div className='flex flex-align-center gap-10'>
                        <Tooltip titleText={member.status}>
                            <span>
                                <Icon
                                    iconName='FiberManualRecord'
                                    style={{
                                        color: member.statusColor,
                                        fontSize: '20px',
                                    }}
                                />
                            </span>
                        </Tooltip>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default MemberCard;
